import WizardRenderer from './src/WizardRenderer.vue';

export default WizardRenderer;
